var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #8e8e98;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #363c4f;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      visibility: "hidden"
    },
    id: "Layer_2",
    "data-name": "Layer 2"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.6,6.2c-4.86,0-8.8,2.63-8.8,5.87s3.94,5.87,8.8,5.87h8.8v-5.87c0-3.24-3.94-5.87-8.8-5.87Zm0,8.8c-2.7,0-4.89-1.31-4.89-2.93s2.19-2.93,4.89-2.93,4.89,1.31,4.89,2.93-2.19,2.93-4.89,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.8,19.27c0,3.24,3.94,5.87,8.8,5.87h13.6v-7.21H13.6c-4.86,0-8.8-2.63-8.8-5.87v7.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.2,18.43c-.13,0-.26-.05-.35-.14-.05-.05-.09-.1-.11-.16-.03-.07-.04-.13-.04-.2,0-.13,.05-.26,.15-.35,.19-.19,.51-.19,.71,0,.09,.09,.14,.22,.14,.35,0,.07-.01,.13-.04,.2-.02,.06-.06,.11-.1,.16-.1,.09-.23,.14-.36,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.7,16.01c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-1.92c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-1.92c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Zm0-1.92c0-.27,.22-.5,.5-.5h0c.28,0,.5,.23,.5,.5h0c0,.28-.22,.5-.5,.5h0c-.28,0-.5-.22-.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.2,8.83c-.13,0-.26-.05-.35-.14-.05-.05-.09-.11-.11-.17-.03-.06-.04-.12-.04-.19,0-.13,.05-.26,.15-.35,.19-.19,.51-.19,.71,0,.09,.09,.14,.22,.14,.35,0,.07-.01,.13-.04,.19-.02,.06-.06,.12-.1,.17-.1,.09-.23,.14-.36,.14Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.21,
    y: 21.44,
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.72,
    y: 21.44,
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.23,
    y: 21.44,
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.7,
    y: 21.44,
    width: 1,
    height: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.74,
    y: 21.44,
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.26,
    y: 21.44,
    width: 1,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.77,
    y: 21.44,
    width: 1,
    height: 3.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.28,
    y: 20.83,
    width: 1,
    height: 3.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.79,
    y: 19.66,
    width: 1,
    height: 3.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.6,18.43v-1c4.58,0,8.3-2.41,8.3-5.37s-3.72-5.37-8.3-5.37-8.3,2.41-8.3,5.37h-1c0-3.51,4.17-6.37,9.3-6.37s9.3,2.86,9.3,6.37-4.17,6.37-9.3,6.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.9,
    y: 12.07,
    width: 1,
    height: 5.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27.7,25.64H13.6c-5.13,0-9.3-2.86-9.3-6.37v-7.21h1c0,2.96,3.72,5.37,8.3,5.37h14.1v8.21ZM5.3,14.94v4.34c0,2.96,3.72,5.37,8.3,5.37h13.1v-6.21H13.6c-3.62,0-6.76-1.42-8.3-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.6,15.5c-3.02,0-5.39-1.51-5.39-3.43s2.37-3.43,5.39-3.43,5.39,1.51,5.39,3.43-2.37,3.43-5.39,3.43Zm0-5.87c-2.38,0-4.39,1.11-4.39,2.43s2.01,2.43,4.39,2.43,4.39-1.11,4.39-2.43-2.01-2.43-4.39-2.43Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/Measure.16b63e8fb664368cd8618483c5fb2893.svg";
export { ForwardRef as ReactComponent };